import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AppStoreService } from '@core/store/app-store.service';
import { Template } from '../../models/template';
import { ConfigService } from '@core/services/config.service';
import { TemplateStoreService } from '@modules/template/student/store/services/template-store.service';
import { ClassroomCourse, ClassroomCourseFilter } from '@modules/course/classroom/models';
import { Multimedia } from '@shared/models/multimedia';
import { TRANSLATION_SCOPE } from '../../i18n/scope';

@Component({
  selector: 'app-template-details',
  templateUrl: './template-details.component.html',
  styleUrls: ['./template-details.component.scss'],
})
export class TemplateDetailsComponent implements OnInit, OnDestroy {
  readMoreText = false;
  translationScope = TRANSLATION_SCOPE;
  description =
    'Våre instruktører er klare til å dele kunnskap innenfor hastighetskjøring med fritidsbåt. Kursutvikler og fagansvarlig for fritidsbåt i Redningsselskapet Pål Virik Nilsen har over 30 års fartstid innenfor internasjonal båtsport og båtliv. Pål er tidligere Verdensmester og har kjørt for flere av de største teamene i verden. Dette har gitt han en unik erfaring i håndtering av båt i hastighet. Han har skrevet to bøker og hastighetskjøring «Helt Propell» i 2015 og «Båt i hastighet» i 2018. Her har du en fin mulighet til å dra nytte av hans erfaringer og kunnskap. Kompendiet er utviklet av Virik Nilsen og er bygget mye fra hans bakgrunn som båtfører.';

  slideConfig = {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    infinite: false,
  };

  template$: Observable<Template>;
  classrooms$: Observable<ClassroomCourse[]>;

  constructor(
    private route: ActivatedRoute,
    private configService: ConfigService,
    private templateStore: TemplateStoreService,
    private appStoreService: AppStoreService
  ) {
    this.appStoreService.setHomePageFlag(true);
  }

  ngOnInit(): void {
    const templateId = this.route.snapshot.params.id;
    this.template$ = this.templateStore.getTemplate(templateId);
    this.classrooms$ = this.templateStore.getClassroomCourses();
  }

  ngOnDestroy(): void {
    this.templateStore.removeClassroomCourses();
    this.appStoreService.setHomePageFlag(false);
  }

  getDefaultMedia(media: Multimedia[]): string {
    if (media.length) {
      return media.find((media) => media.default == true).url;
    } else {
      return this.defaultBanner();
    }
  }

  getVideo(medias: Multimedia[]): Multimedia {
    return medias.find((media) => media.default == false && media.contentType === 'video/mp4');
  }

  getSlideImages(medias: Multimedia[]): Multimedia[] {
    return medias.filter((media) => media.default == false && media.contentType !== 'video/mp4');
  }

  readMore(): void {
    this.readMoreText = !this.readMoreText;
  }

  defaultBanner(): string {
    const env = this.configService.getCurrent().env;

    switch (env) {
      case 'production':
        return 'https://rssjoliv-prod.imgix.net/harbour/harbour_default_banner.png';
      case 'staging':
        return 'https://rssjoliv-staging.imgix.net/harbour/harbour_default_banner.png';
      default:
        return 'https://rssjoliv-dev.imgix.net/harbour/harbour_default_banner.png';
    }
  }
}
